import { usePaginatedSelectionContext } from '@autone/ui-next/components';
import { useMemo } from 'react';

import { useGetAssortmentSkuLocationsCountQuery } from '../../../../redux/assortment';
import { type GetAssortmentSkuLocationsCountRequestBody } from '../../../../redux/assortment/types/assortment-get-sku-locations-count.types';
import { parseRowId } from '../utilities/row-id';

import { useGetSkuLocationsTableQueryArgs } from './useGetSkuLocationsTableQueryArgs';

export const useGetSkuLocationsTableSelectionCounts = () => {
  const {
    body: {
      filters,
      advanced_filter,
      is_managed_by_user,
      matches_system_recommendation,
    },
  } = useGetSkuLocationsTableQueryArgs({
    searchTerm: '',
  });
  const [selectionState] = usePaginatedSelectionContext();

  const skuLocationsCountQueryArgs: GetAssortmentSkuLocationsCountRequestBody =
    useMemo(() => {
      if (selectionState.mode === 'bulk') {
        return {
          selection: {
            selection_type: 'criteria',
            filters,
            advanced_filter,
            is_managed_by_user,
            matches_system_recommendation,
            sku_locations_to_exclude: selectionState.excludeList.map(
              (rowId) => {
                const { skuId, locationId } = parseRowId(rowId);
                return { sku_id: skuId, location_id: locationId };
              },
            ),
          },
        };
      } else {
        return {
          selection: {
            selection_type: 'sku_location_list',
            sku_locations: selectionState.includeList.map((rowId) => {
              const { skuId, locationId } = parseRowId(rowId);
              return { sku_id: skuId, location_id: locationId };
            }),
          },
        };
      }
    }, [
      selectionState,
      filters,
      advanced_filter,
      is_managed_by_user,
      matches_system_recommendation,
    ]);

  return useGetAssortmentSkuLocationsCountQuery({
    body: skuLocationsCountQueryArgs,
  });
};
